import * as R from 'ramda';
import { useQuery, useMutation } from '@cd/react-query';
import { postJSONPS, either } from '@cd/utils';
import { useStore } from './store';

export function useQueryFetch(queryName, url, method = 'POST', params = {}) {
	const { dispatch } = useStore();

	return useQuery(
		[queryName, ...R.keys(params)],
		() =>
			new Promise((resolve, reject) =>
				postJSONPS(
					method,
					url,
					R.toUpper(method) === 'POST'
						? { body: JSON.stringify(params) }
						: {}
				).then(
					either(e => {
						const commonErrorStr =
							e.message || e?.raw?.message || e;

						dispatch({ type: 'post error', e: commonErrorStr });
						reject(commonErrorStr);
					}, resolve)
				)
			)
	);
}

export function useMutationFetch(url, options = {}) {
	const { dispatch } = useStore();
	const { mutate, ...rest } = useMutation({
		mutationFn: mutateParams => {
			return new Promise((resolve, reject) =>
				postJSONPS('POST', url, {
					body: JSON.stringify(mutateParams)
				}).then(
					either(e => {
						const commonErrorStr =
							e.message || e?.raw?.message || e;
						dispatch({ type: 'post error', e: commonErrorStr });
						reject(commonErrorStr);
					}, resolve)
				)
			);
		},
		...options
	});

	return { mutate, ...rest };
}
